$(document).ready(function () {
  const mobile_nav = {
    expand_nav: function () {
      $(".menu-nav__with-dropdown .toggle-icon").on("click", function () {
        $(this).closest(".menu-nav__with-dropdown").toggleClass("active");
        const menu_to_toggle = $(this).closest(".menu-nav__with-dropdown").data("title");
        $(`[data-parent="${menu_to_toggle}"]`).slideToggle();
      });
    },
    open_nav: function () {
      $(".mobile-nav--open").on("click", function () {
        $("body").addClass("show-menu-drawer");
      });
      $(".menu-popup-overlay").on("click", function () {
        $("body").removeClass("show-menu-drawer");
      });
    },
  };
  mobile_nav.expand_nav();
  mobile_nav.open_nav();
});
